import React, { memo,useMemo, useCallback, useEffect } from 'react';
import { Select2 } from "select2-react-component";
import {FormBlocks} from './FormBlocks';
import {isSet,currencyListUtil,userUtilList,isEmptyValueExist} from '../../../../Utils/CommonFunctions';
import {formFieldsAttributes} from '../../FormBuilderFunctions/FieldProps';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import {
  dropDownFieldMappingAction
} from '../../../../store/actions/formBuilderActions';

const PickList = (props)=>{
  const  {
    item,
    className,
    validationForms,
    fieldObj
  } = props;

  const onChangePickList = useCallback((value,fieldType)=>{
    if(!props.onChangeInputAction) {
      return false;
    }
    let isMappingExist = false,isMappingNotNull = false,addedDependency = null;
    try{
       props.onChangeInputAction(fieldObj,value,fieldType);
       const itemOption = (item.unFilterOption)?item.unFilterOption:item.options;
       itemOption.map((option,index)=>{
          if(option.dependency_map && option.dependency_map!==null){
           isMappingExist = true;
           const dependencyMap = option.dependency_map;
           addedDependency  = dependencyMap;
           if(option.id===value){
             isMappingNotNull = true;
             props.dropDownFieldMappingAction(fieldObj,dependencyMap);
           }
          }
       })
       if(isMappingNotNull===false && isMappingExist===true){
         props.dropDownFieldMappingAction({...fieldObj,dependencyNull:true},addedDependency);
       }
    }catch(e){
      console.log('exception',e);
    }  
  });
  const selectOptionsState = useMemo(() => {
    let selectOptions = [{label:'-None-',value:''}];
    const options = item.options;
    try{
      if(item.picklist_type==='CURRENCY'){
        const currencyList =  currencyListUtil();
        currencyList.map((currency)=>{
          selectOptions.push({
              label:currency.value,
              value:currency.key
          });
        });
      }else if(item.picklist_type==='COUNTRY'){
        const countryList =  (userUtilList().country_list!==undefined && userUtilList().country_list!==null)?userUtilList().country_list:{};
        Object.keys(countryList).forEach(function(key) {
          selectOptions.push({
            value: key,
            label: countryList[key],
          })
        })
      }else{
        selectOptions = options.map((item,index)=>{
          return(
            {
              label:item.value,
              value:item.id,
            }
          )
        })
      }
      if(isEmptyValueExist(selectOptions) === false) {
        selectOptions.unshift({label:'-None-',value:''});
      }
      // setOptionsState(selectOptions);
    }catch(e){

    }
    return selectOptions;
  }, [item.options]);

  useEffect(()=>{
    if(item.overridden===false){
      onChangePickList(isSet(attr.value,''),'PickList')
    }
  },[item.overridden]);


  const attr = formFieldsAttributes(
    {...item,className:className
  },validationForms);
 
  let tabClass = 'nav nav-pills navcrm-primary nav-pills-no-bd p-2 pl-2';
  let tabListClass = 'nav-item submenu';
  let tabAnchorClass = 'nav-link';
  let svgIcons ='';
  if(isSet(props.item.displayType,props.displayType)==='Tabs'){
    try{
      tabClass = isSet(props.item.customAttr.tabclass,'nav nav-pills navcrm-primary nav-pills-no-bd p-2 pl-2');
      tabListClass =  isSet(props.item.customAttr.tablistclass,'nav-item submenu');
      tabAnchorClass =  isSet(props.item.customAttr.tabanchorclass,'nav-link');
      svgIcons =  isSet(props.item.customAttr.svgicons,'');
    }catch(e){

    }
  }
   return (
    <FormBlocks {...props}  attr={attr}>
      {(isSet(props.item.displayType,props.displayType)==='Tabs')?
        <ul className={tabClass}> 
        {selectOptionsState.map((itm,itmIndex)=>{
          if(itm.value===''){return false};
          let svgIcon = '';
          try{   
            const regex = new RegExp(`<${itm.label}[^>]*>([\\s\\S]*?)<\\/${itm.label}>`, "g");
            const matches = [...svgIcons.matchAll(regex)].map(match => match[1]);
            svgIcon =  <span style={{marginRight:'5px',marginLeft:'5px'}} dangerouslySetInnerHTML={{ __html: matches[0] }} />
          }catch(e){

          }
          const isSelected = (itm.value===isSet(attr.value?.value,attr.value) || itm.label===isSet(attr.value?.value,attr.value))?'active show':'';
          return(
            <li className={tabListClass} key={itmIndex} onClick={()=>onChangePickList(itm.value,'PickList')}>
							  <a className={`${tabAnchorClass} ${isSelected}`}  id="base-pill3"  href="#" aria-expanded="true" >
                  {svgIcon}
								  {itm.label}
                  
                </a>
					  </li>
          )
        })}
        </ul>
      :
      <div className={item.required===true ? "mandatory select2-arrow" : "select2-arrow" }>
        <Select2 
          data={selectOptionsState}
          {...attr.fieldAttributes}
          disabled={attr.fieldAttributes.readOnly}
          minCountForSearch ={1}
          value={attr.value}
          update={value => onChangePickList(value,'PickList')} >
        </Select2>
      </div>
      }
    </FormBlocks>
  );

}

PickList.defaultProps = {
  displayType:'Default',
  disabled: false,
  generator: false,
  className: 'form-control'
}


const mapDispatchToProps = dispatch => {
  return {
    dropDownFieldMappingAction:(obj,val)=>dispatch(dropDownFieldMappingAction(obj,val)),
  };
}
const isDiffProps = (prevProps,nextProps)=>{
  if(prevProps.item===nextProps.item && prevProps.validationForms===nextProps.validationForms && prevProps.item.access_mode===nextProps.item.access_mode && prevProps.item.required===nextProps.item.required){
    return true;
  }
}
export default
  connect(
    null,
    mapDispatchToProps
  )(withRouter(memo(PickList,isDiffProps)));
